<template>
  <nav class="nav">
    <ul class="list">
      <li>
        <NuxtLink
          :to="localePath('/')"
          active-class="active"
        >
          <i class="i-analitycs" />
          {{ t("main") }}
        </NuxtLink>
      </li>
      <li>
        <button
          activeClass="active"
          @click.stop="
            featuresVisible = !featuresVisible;
            overlay = true;
          "
        >
          <i class="i-comparison" />
          {{ t("additional.features") }}
        </button>

        <div
          v-show="featuresVisible"
          class="catalog"
          @click.stop=""
        >
          <button
            class="catalog__back"
            @click.stop="
              featuresVisible = !featuresVisible;
              overlay = true;
            "
          >
            <i class="i-arrow" />
            <span>{{ t("additional.features") }}</span>
          </button>
          <NuxtLink
            :to="localePath('/comparison')"
            class="catalog__item"
            @click="closeOverlay"
          >
            <img
              alt=""
              src="/img/catalog/price.svg"
            >
            <span>{{ t("price_comparison") }}</span>
          </NuxtLink>
          <NuxtLink
            :to="localePath('/search')"
            class="catalog__item"
            @click="closeOverlay"
          >
            <img
              alt=""
              src="/img/catalog/advanced-search.svg"
            >
            <span>{{ t("homepage.features['Advanced search']") }}</span>
          </NuxtLink>
          <NuxtLink
            :to="localePath('/trade-up')"
            class="catalog__item"
            @click="closeOverlay"
          >
            <img
              alt=""
              src="/img/catalog/trade.svg"
            >
            <span>{{ t("trade_up_contract") }}</span>
          </NuxtLink>
          <NuxtLink
            :to="localePath('/inventory')"
            class="catalog__item"
            @click="closeOverlay"
          >
            <img
              alt=""
              src="/img/catalog/price.svg"
            >
            <span>{{ t("inventory.checker.title") }}</span>
          </NuxtLink>
        </div>
      </li>
      <li>
        <NuxtLink
          :to="localePath('/pricing')"
          active-class="active"
        >
          <svg>
            <use xlink:href="/icons/sprite.svg#i-pricing" />
          </svg>
          {{ t("pricing") }}
        </NuxtLink>
      </li>
      <li>
        <button
          activeClass="active"
          @click.stop="
            othersVisible = !othersVisible;
            overlay = true;
          "
        >
          <svg>
            <use xlink:href="/icons/sprite.svg#i-others" />
          </svg>
          {{ t("categories.Other") }}
        </button>
        <div
          v-show="othersVisible"
          class="catalog catalog-second"
          @click.stop=""
        >
          <button
            class="catalog__back"
            @click.stop="
              othersVisible = !othersVisible;
              overlay = true;
            "
          >
            <i class="i-arrow" />
            <span>{{ t("categories.Other") }}</span>
          </button>
          <NuxtLink
            :to="localePath('/tournaments')"
            class="catalog__item"
            @click="closeOverlay"
          >
            <img
              alt=""
              src="/img/catalog/Image.svg"
            >
            <span>{{ t("tournaments") }}</span>
          </NuxtLink>
          <NuxtLink
            :to="localePath('/teams')"
            class="catalog__item"
            @click="closeOverlay"
          >
            <img
              alt=""
              src="/img/catalog/Image-1.svg"
            >
            <span>{{ t("teams_label") }}</span>
          </NuxtLink>
          <NuxtLink
            :to="localePath('/pro-players')"
            class="catalog__item"
            @click="closeOverlay"
          >
            <img
              alt=""
              src="/img/catalog/players.svg"
            >
            <span>{{ t("players") }}</span>
          </NuxtLink>
          <NuxtLink
            :to="localePath('/markets')"
            class="catalog__item"
            @click="closeOverlay"
          >
            <img
              alt=""
              src="/img/catalog/Image-2.svg"
            >
            <span>{{ t("all_markets") }}</span>
          </NuxtLink>
          <NuxtLink
            :to="localePath('/collections')"
            class="catalog__item"
            @click="closeOverlay"
          >
            <img
              alt=""
              src="/img/catalog/Image-3.svg"
            >
            <span>{{ t("Collections") }}</span>
          </NuxtLink>
          <NuxtLink
            :to="localePath('/blog')"
            class="catalog__item"
            @click="closeOverlay"
          >
            <img
              alt=""
              src="/img/catalog/blog.svg"
            >
            <span>{{ t("blog") }}</span>
          </NuxtLink>
        </div>
      </li>
    </ul>
    <div
      v-if="overlay"
      class="overlay"
      @click.stop="closeOverlay"
    />
  </nav>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const localePath = useLocalePath();
const { t } = useI18n();

const featuresVisible = ref<boolean>(false);
const othersVisible = ref<boolean>(false);
const overlay = ref<boolean>(false);

function closeOverlay() {
  featuresVisible.value = false;
  othersVisible.value = false;
  overlay.value = false;
}
</script>

<style lang="scss" scoped>
nav {
  flex-grow: 1;
}

ul {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  a,
  button {
    padding: 1rem 1.6rem;
    font-size: 1.4rem;
    font-weight: 800;
    text-transform: uppercase;
    color: var(--surfaces-on-surface-variable);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    i,
    svg {
      font-size: 1.8rem;
      margin-right: 0.8rem;
    }

    svg {
      width: 1.8rem;
      height: 1.8rem;
    }

    &:hover {
      color: var(--white);
    }

    &.router-link-exact-active {
      color: var(--white);
    }

    @media (max-width: 1115px) {
      width: 100%;
      justify-content: flex-start;
      border-radius: 12px;
      color: var(--surfaces-on-surface-variable);
      &:deep(svg) {
        path {
          fill: var(--surfaces-on-surface-variable);
        }
      }
      &:hover {
        background: var(--surfaces-variable-container);
        color: var(--white);

        &:deep(svg) {
          path {
            fill: var(--white);
          }
        }
      }
    }

    &.nuxt-link-exact-active {
      color: var(--accent-on-accent-secondary);
    }
  }

  .active {
    color: var(--accent-on-accent-secondary);
    @media (max-width: 1115px) {
      background: var(--surfaces-variable-container);
      color: var(--white);
      &:deep(svg) {
        path {
          fill: var(--white);
        }
      }
    }
  }

  li {
    position: relative;

    .catalog {
      position: absolute;
      z-index: 20;
      top: calc(100% + 16px);
      display: grid;
      grid-template-columns: repeat(4, 8rem);
      gap: 0.2rem;
      background: var(--surfaces-variable-container);
      padding: 1.2rem;
      border-radius: 1.2rem;
      animation: opacity 0.3s ease-in-out;

      &-second {
        grid-template-columns: repeat(6, 8rem);
      }

      @media (max-width: 1115px) {
        position: fixed;
        z-index: 1;
        right: 0;
        bottom: 0;
        top: 70px;
        width: 100%;
        max-width: 450px;
        background: var(--surfaces-surface);
        padding: 24px 16px 16px 16px;
        display: flex;
        flex-direction: column;
        gap: 0;
      }

      &__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.8rem;
        text-align: center;
        font-weight: 600;
        font-size: 1.2rem;
        line-height: 1.5;
        padding: 0;
        margin: 0;

        &:hover {
          img {
            scale: 1.1;
          }
        }

        img {
          width: 6.4rem;
          height: 6.4rem;
          transition: all 0.3s ease;
        }

        span {
          text-transform: lowercase;

          &::first-letter {
            text-transform: uppercase;
          }
        }

        @media (max-width: 1115px) {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          gap: 8px;
          padding: 8px;
          border-radius: 12px;
          font-size: 14px;
          img {
            width: 24px;
            height: 24px;
          }
          &:hover {
            background: var(--surfaces-variable-container);
          }
        }
      }

      &__back {
        display: none;
        align-items: center;
        color: var(--accent-on-surface);
        font-size: 14px !important;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
        margin: 0 !important;
        padding: 0 !important;
        gap: 4px !important;
        margin-bottom: 24px !important;
        justify-content: flex-start;

        .i-arrow {
          transform: rotate(90deg);
          font-size: 14px !important;
          font-weight: 600;
        }

        @media (max-width: 1115px) {
          display: flex;
        }

        &:hover {
          background: transparent;
        }
      }
    }

    @media (max-width: 1115px) {
      width: 100%;
    }
  }
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.overlay {
  content: "";
  background: color-mix(in srgb, var(--accent-on-primary) 90%, transparent);
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  @media (max-width: 1115px) {
    display: none;
  }
}
</style>
